import React from 'react';

function EnConstruction() {
  return (
    <div className="container text-center">
      <div className="col-lg-12 col-md-12 mb-30">
        <div className="section-title">
          <h2>Page en Construction</h2>
          <p >Veuillez patienter durant la construction de cette page.</p>
        </div>
      </div>
      <div className="feature-box">
        <h4>Merci de votre compréhension</h4>
        <p className="no-dark-mode">Nous mettons tout en œuvre pour que cette page soit disponible rapidement.</p>
        <a href="/" className="btn-style-1">Retour à l'accueil</a>
      </div>
    </div>
  );
}

export default EnConstruction;